export enum CompanyMainActivities {
  INVESTMENTS_IN_SECURITIES = "investments-in-securities",
  HOLDING = "holding",
  INVESTMENTS_IN_ALTERNATIVES = "investments-in-alternatives",
  OTHER = "other"
}
